
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 20 19","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6.72 3.23C7.596 1.43 8.034.53 8.618.226a2 2 0 011.85 0c.584.304 1.022 1.204 1.898 3.002l.09.183c.258.532.388.799.575 1.007a2 2 0 00.676.491c.257.114.55.155 1.136.237l.202.029c1.981.277 2.972.415 3.442.877a2 2 0 01.572 1.759c-.11.65-.83 1.345-2.27 2.733l-.146.142c-.426.41-.639.616-.78.86-.14.243-.229.514-.258.794-.029.279.023.57.126 1.153l.035.2c.35 1.97.523 2.955.23 3.546a2 2 0 01-1.497 1.087c-.652.097-1.535-.373-3.3-1.314l-.18-.095c-.523-.279-.784-.418-1.058-.476a2 2 0 00-.836 0c-.274.058-.536.197-1.058.476l-.18.095c-1.765.94-2.648 1.41-3.3 1.314A2 2 0 013.09 17.24c-.293-.59-.12-1.576.23-3.545l.035-.2c.103-.584.155-.875.126-1.154a2 2 0 00-.259-.795c-.14-.243-.353-.448-.78-.86l-.146-.14C.856 9.155.136 8.461.027 7.811A2 2 0 01.6 6.053c.47-.462 1.46-.6 3.442-.877l.202-.029c.586-.082.879-.123 1.136-.237a2 2 0 00.675-.49c.188-.21.318-.476.577-1.008l.089-.183z","stroke":"#FFBB1E"}})])
          )
        }
      }
    